module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/75b3b88fea61068b8aefdf24d7d75530.png";